import ReactQuill from 'react-quill';
import Quill from 'quill';
import 'react-quill/dist/quill.snow.css';
import { Stack, useTheme } from '@mui/material';

interface EditorToolBarProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
}

const Clipboard = Quill.import('modules/clipboard');

class CustomClipboard extends Clipboard {
  async onPaste(e: ClipboardEvent) {
    e.preventDefault();
    const text = e.clipboardData?.getData('text/plain') ?? '';
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const range = this.quill.getSelection(true);
    let index = range?.index ?? this.quill.getLength();

    const parts: string[] = text.split(urlRegex);
    for (const part of parts) {
      if (urlRegex.test(part)) {
        this.quill.insertText(index, part, 'link', part, 'user');
      } else {
        this.quill.insertText(index, part, 'user');
      }
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      index += part.length;
    }

    this.quill.setSelection(index, 'silent');
  }
}

let clipboardRegistered = false;

if (!clipboardRegistered) {
  Quill.register('modules/clipboard', CustomClipboard, true);
  clipboardRegistered = true;
}

const EditorToolBar = ({ value, onChange, readOnly = false }: EditorToolBarProps) => {
  const theme = useTheme();

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      ['link'],
      ['clean'],
    ],
    clipboard: true,
  };
  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'color',
    'background',
    'link',
  ];

  return (
    <Stack
      sx={{
        width: '100%',
        '& .quill': {
          borderRadius: '5px',
          border: `1px solid ${theme.palette.grey[300]}`,
        },
        '& .ql-toolbar': {
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '& .ql-container': {
          minHeight: '120px',
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px',
          backgroundColor: theme.palette.common.white,
        },
      }}
    >
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        readOnly={readOnly}
      />
    </Stack>
  );
};

export { EditorToolBar };
